import { FC, ReactNode, useEffect, useRef } from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

export type MultiDropdownItemProps = {
  children: ReactNode;
  onSelect: () => void;
  isFocused: boolean;
  isSelected: boolean;
  className?: string;
};

export const MultiDropdownItem: FC<MultiDropdownItemProps> = ({
  children,
  onSelect,
  isFocused,
  isSelected,
  className,
}) => {
  const ref = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (isFocused) {
      ref.current?.focus();
    }
  }, [isFocused]);

  return (
    <li
      ref={ref}
      className={clsx('dropdown-item', className)}
      role="option"
      aria-selected={isSelected}
      style={{
        padding: 0,
      }}
      tabIndex={0}
    >
      <label className={clsx('w-100', styles.label)}>
        <input type="checkbox" checked={isSelected} onChange={onSelect} />
        <div className="faux-input" />
        <span>{children}</span>
      </label>
    </li>
  );
};
